import { IgenomicsAction } from '../interfaces/genomics-action.interface';
import { StorePayloadTypes } from '../interfaces/store-payload-types.interface';
import { GeneralStoreEntity } from '../entities/general-store.entity';
import { CORE_ACTIONS } from '../constants/core-actions.constant';
import { IgenomicsCastAction } from '../interfaces/genomics-cast-action.interface';

export function simpleActionCreator<T>(type: string): (payload: T) => IgenomicsAction<T> {
  return (payload: T) => {
    payload = GeneralStoreEntity.builder(payload);
    return ({ type, payload});
  };
}

export function cacheActionCreator<T>(type: string): (payload: T, payloadType: StorePayloadTypes) => IgenomicsCastAction<T> {
  return (payload: T, payloadType: StorePayloadTypes) => {
    return ({ type: CORE_ACTIONS.CAST_ACTION, payload: (<any> payloadType).builder(payload).setIdentifier(), callbackType: type});
  };
}

export function cacheSyncActionCreator<T>(type: string): (payload: T, payloadType: StorePayloadTypes) => IgenomicsAction<T> {
  return (payload: T, payloadType: StorePayloadTypes) => {
    payload = (<any> payloadType).builder(payload).setIdentifierSync();
    return ({ type, payload});
  };
}


